import { EXECS } from '../data/execs';

function execAvatar(seed: number) {
  const a = (seed * 47) % 360;
  return (
    <svg
      viewBox="0 0 200 250"
      preserveAspectRatio="xMidYMid slice"
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
    >
      <defs>
        <linearGradient id={'eg' + seed} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={`hsl(${a}, 4%, 90%)`} />
          <stop offset="1" stopColor={`hsl(${a}, 5%, 70%)`} />
        </linearGradient>
      </defs>
      <rect width="200" height="250" fill={`url(#eg${seed})`} />
      <circle cx="100" cy="100" r="36" fill="rgba(0,0,0,0.16)" />
      <path
        d="M30,250 C 40,190 70,168 100,168 C 130,168 160,190 170,250 Z"
        fill="rgba(0,0,0,0.16)"
      />
    </svg>
  );
}

export default function Leadership() {
  const inside = EXECS.filter((e) => e.inside);
  const outside = EXECS.filter((e) => !e.inside);

  return (
    <section id="leadership" className="section section--paper">
      <div className="container">
        <div className="section-head">
          <div>
            <div className="eyebrow">
              <span className="bar" />
              <span>Leadership</span>
            </div>
            <h2 className="h2">
              Stewards,
              <br />
              not speculators.
            </h2>
          </div>
          <p className="lede">
            Mystar Engineering's group leadership pairs a founding-family steward with
            long-tenure executives drawn from top-tier engineering, strategy and
            finance backgrounds. Below are the directors and outside members of the
            audit &amp; supervisory board, as of 2026.
          </p>
        </div>

        <div className="exec-divider">
          <span className="lbl">
            <span style={{ color: 'var(--red)' }}>● </span>Directors
          </span>
          <span className="line" />
        </div>
        <div className="exec-grid">
          {inside.map((e, i) => (
            <article className="exec" key={i}>
              <div className="portrait">
                {e.photo ? (
                  <img src={e.photo} alt={e.name} className="portrait-img" />
                ) : (
                  execAvatar(i + 1)
                )}
              </div>
              <div className="body">
                <div className="role">{e.role}</div>
                <div className="role-sub">{e.sub || '\u00A0'}</div>
                <div className="name-en">{e.name}</div>
                <p className="bio">{e.bio}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="exec-divider">
          <span className="lbl">Outside Directors &amp; Auditor</span>
          <span className="line" />
        </div>
        <div className="exec-grid">
          {outside.map((e, i) => (
            <article className="exec is-outside" key={i}>
              <div className="portrait">
                {e.photo ? (
                  <img src={e.photo} alt={e.name} className="portrait-img" />
                ) : (
                  execAvatar(i + 10)
                )}
              </div>
              <div className="body">
                <div className="role">{e.role}</div>
                <div className="role-sub">{e.sub || '\u00A0'}</div>
                <div className="name-en">{e.name}</div>
                <p className="bio">{e.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
